import { Dispatch } from "redux";
import Config from "config";
import axios from "axios";

// Types
export interface RequestDetails {
    requestId?: string;
    description?: string;
    requestType?: string;
    chainName?: string;
    requestedBy?: string;
    email?: string;
    role?: string;
    requestRaisedOn?: any;
    status?: string | any;
    stores?:string;
    requestDescription?:string;
    request_initiator_user_id?:number;
    fromStatusId?: number | null;
    fromStatusCode?: string | null;
    toStatusId?: number | null;
    toStatusCode?: string | null;
    currentApproverRole: string;
    workInProgressBy: string;
    requestChain:string | any;
}

export interface RequestDetailsState {
    data: RequestDetails | null;
    loading: boolean;
    error: string | null;
}

// Action Types
const FETCH_REQUEST_DETAILS = "FETCH_REQUEST_DETAILS";
const FETCH_REQUEST_DETAILS_SUCCESS = "FETCH_REQUEST_DETAILS_SUCCESS";
const FETCH_REQUEST_DETAILS_FAILURE = "FETCH_REQUEST_DETAILS_FAILURE";

// Action Creator
export const fetchRequestDetails = (requestId: string) => {
    return async (dispatch: Dispatch) => {
        dispatch({ type: FETCH_REQUEST_DETAILS });

        try {
            const response = await axios.get(
                `${Config.API_SERVICE_URL}/api/request/${requestId}`
            );

            const details: RequestDetails =
                response.data.data || response.data;

            dispatch({
                type: FETCH_REQUEST_DETAILS_SUCCESS,
                payload: details
            });

            return details;
        } catch (error: any) {
            console.error("Error fetching request details:", error);

            dispatch({
                type: FETCH_REQUEST_DETAILS_FAILURE,
                payload: error.message || "Failed to fetch request details"
            });

            throw error;
        }
    };
};

// Initial State
const initialState: RequestDetailsState = {
    data: null,
    loading: false,
    error: null
};

// Reducer
export const requestDetailsReducer = (
    state = initialState,
    action: any
): RequestDetailsState => {
    switch (action.type) {
        case FETCH_REQUEST_DETAILS:
            return {
                ...state,
                loading: true,
                error: null
            };

        case FETCH_REQUEST_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null
            };

        case FETCH_REQUEST_DETAILS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        default:
            return state;
    }
};

export default requestDetailsReducer;